import React from "react";
import { X } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { formatDate } from "./adminUi";

// v9.50 Sprint 3 — manual grant modal. ONLY talks to POST /admin/users/{id}/plan-grant
// via the parent's onSubmit. Never creates/modifies/cancels a Stripe subscription.
export default function GrantModal({ state, setState, onSubmit, onClose }) {
  const durationLabel = state.duration === "one_month" ? "1 mese"
    : state.duration === "one_year" ? "1 anno" : "Senza scadenza";
  const planLabel = state.plan === "basic" ? "Basic" : state.plan === "pro" ? "Pro" : "AI Manager";
  const kindLabel = state.grant_kind === "gift" ? "Omaggio" : "Manuale";

  const now = new Date();
  const target = state.duration === "one_month" ? new Date(now.getFullYear(), now.getMonth()+1, now.getDate())
    : state.duration === "one_year" ? new Date(now.getFullYear()+1, now.getMonth(), now.getDate())
    : null;
  const rangeLabel = state.duration === "permanent"
    ? "Senza scadenza"
    : `Dal ${formatDate(now.toISOString())} al ${target ? formatDate(target.toISOString()) : "—"}`;

  return (
    <div className="fixed inset-0 z-[60] flex items-center justify-center bg-black/50 p-4" data-testid="admin-grant-modal">
      <div className="bg-white rounded-lg shadow-xl w-full max-w-md p-6 max-h-[92vh] overflow-y-auto">
        <div className="flex items-center justify-between mb-4">
          <h3 className="font-serif-heading text-xl">Assegna / modifica piano</h3>
          <button className="p-1.5 rounded-full hover:bg-neutral-100" onClick={onClose} data-testid="grant-close">
            <X className="w-4 h-4" strokeWidth={2} />
          </button>
        </div>

        <div className="space-y-4 text-sm">
          <div>
            <div className="label-uppercase text-neutral-600 mb-1">Piano</div>
            <div className="grid grid-cols-3 gap-2">
              {[["basic","Basic"],["pro","Pro"],["ai_manager","AI Manager"]].map(([v,l]) => (
                <button
                  key={v}
                  className={`px-3 py-2 rounded-md border text-xs ${state.plan===v?"bg-neutral-900 text-white border-neutral-900":"bg-white border-neutral-200 hover:bg-neutral-50"}`}
                  onClick={() => setState({...state, plan:v})}
                  data-testid={`grant-plan-${v}`}
                >{l}</button>
              ))}
            </div>
          </div>
          <div>
            <div className="label-uppercase text-neutral-600 mb-1">Durata</div>
            <div className="grid grid-cols-3 gap-2">
              {[["one_month","1 mese"],["one_year","1 anno"],["permanent","Senza scadenza"]].map(([v,l]) => (
                <button
                  key={v}
                  className={`px-3 py-2 rounded-md border text-xs ${state.duration===v?"bg-neutral-900 text-white border-neutral-900":"bg-white border-neutral-200 hover:bg-neutral-50"}`}
                  onClick={() => setState({...state, duration:v})}
                  data-testid={`grant-duration-${v}`}
                >{l}</button>
              ))}
            </div>
          </div>
          <div>
            <div className="label-uppercase text-neutral-600 mb-1">Tipo</div>
            <div className="grid grid-cols-2 gap-2">
              {[["gift","Omaggio"],["manual","Manuale"]].map(([v,l]) => (
                <button
                  key={v}
                  className={`px-3 py-2 rounded-md border text-xs ${state.grant_kind===v?"bg-neutral-900 text-white border-neutral-900":"bg-white border-neutral-200 hover:bg-neutral-50"}`}
                  onClick={() => setState({...state, grant_kind:v})}
                  data-testid={`grant-kind-${v}`}
                >{l}</button>
              ))}
            </div>
          </div>
          <div>
            <div className="label-uppercase text-neutral-600 mb-1">Motivo (opzionale)</div>
            <Input value={state.reason} onChange={(e)=>setState({...state, reason:e.target.value})}
                    placeholder="es. campagna X, testing…"
                    data-testid="grant-reason" />
          </div>

          <div className="rounded-md bg-neutral-50 border border-neutral-200 p-3 text-xs">
            <div className="font-medium mb-1">Riepilogo</div>
            <div>{planLabel} · {durationLabel} · {kindLabel}</div>
            <div className="text-neutral-500">{rangeLabel}</div>
          </div>

          {state.stripeWarn && (
            <div className="rounded-md bg-amber-50 border border-amber-200 p-3 text-xs text-amber-900" data-testid="grant-stripe-warning">
              <div className="font-medium mb-1">Attenzione — subscription Stripe attiva</div>
              <div>{state.stripeWarn.message}</div>
              <label className="flex items-center gap-2 mt-2">
                <input
                  type="checkbox"
                  checked={!!state.ack}
                  onChange={(e)=>setState({...state, ack:e.target.checked})}
                  data-testid="grant-ack-checkbox"
                />
                <span>Ho verificato e voglio comunque procedere</span>
              </label>
            </div>
          )}

          <div className="pt-2 flex justify-end gap-2">
            <Button variant="ghost" onClick={onClose}>Annulla</Button>
            <Button
              onClick={onSubmit}
              disabled={state.stripeWarn && !state.ack}
              data-testid="grant-submit"
            >
              Conferma attivazione
            </Button>
          </div>
        </div>
      </div>
    </div>
  );
}
